<template>
  <div class="diagram">
    <div class="tag">
      <span :class="tabIdx == 0 ?'active':''" @click="tabMenu(0)">用电量趋势</span>
      <span :class="tabIdx == 1 ?'active':''" @click="tabMenu(1)"
            v-if="$store.getters.projectId == 1 || $store.getters.projectId == 13">发电量趋势</span>
      <span :class="tabIdx == 2 ?'active':''" @click="tabMenu(2)"
            v-if="$store.getters.projectId !== 15 ">变压器实时负载率</span>
      <div v-show="$store.getters.projectId == 1 && tabIdx == 2" style="float: right; margin: 20px 50px 0 0">
        <i><img src="../../../assets/img/blue.png" alt=""> 配电负载率</i>
        <i style="margin-left: 20px"><img src="../../../assets/img/yellow.png" alt=""> 光伏负载率</i>
      </div>
    </div>
    <div class="cont row-center">
      <div :class="tabIdx == 2? 'left full':'left'">
        <!-- <Charts id="chartOption1" v-if="currentArr.length > 0 && isFull" :option="chartOption" ></Charts> -->
        <Charts id="chartOption1" v-if="isFull"
                :option="isFull && $store.getters.projectId !== 1 ? chartOption : chartOptionCH"></Charts>
        <!-- <Loading /> -->
        <!-- <div class="nothing" v-if="currentArr.length == 0"></div> -->
      </div>
      <div :class="tabIdx == 2? 'right hd':'right'" :style="tabIdx == 2?'opacity: 0;':''">
        <span :class="dateIdx==0?'active':''"
              @click="tabDate(0)">{{ tabIdx == 0 ? '日用电趋势' : tabIdx == 1 ? '日发电趋势' : '日负载趋势' }}</span>
        <span :class="dateIdx==1?'active':''"
              @click="tabDate(1)">{{ tabIdx == 0 ? '月用电趋势' : tabIdx == 1 ? '月发电趋势' : '月负载趋势' }}</span>
        <span :class="dateIdx==2?'active':''"
              @click="tabDate(2)">{{ tabIdx == 0 ? '年用电趋势' : tabIdx == 1 ? '年发电趋势' : '年负载趋势' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import {getOverviewReport} from '../../../api/power'
import {dayStart, dayEnd} from '../../../util/DateUtil'
import store from '../../../store/index';
import Loading from '../../../components/common/Loading.vue'
import * as echarts from 'echarts';

export default {
  data() {
    return {

      tabIdx: 0,
      dateIdx: 0,
      temp: [],
      hoursTimeList: [], // 时
      dayTimeList: [], // 天
      monTimeList: [], // 月
      useList: [[], [], []],
      generList: [[], [], []],
      workloadList: [[], [], []],
      currentArr: [],
      menuName: '',
      isFull: true,
      timer: null
    };
  },
  components: {
    Charts, Loading
  },
  computed: {
    mqttval() {
      return this.getMqttVal(this.$store.getters.mqttVal);
    },
    transformerLoad() {
      let arr = []
      let arr2 = []
      let device = []
      let device2 = []
      if (this.$store.getters.projectId == 1) {
        let current = this.$store.state.project.transformerList
        current.forEach(item => {
          let val = this.mqttval('T1/1AA1/3WL/P')
          console.log("val", val)
          let la = this.mqttval(item.subLoopUrl + '/Ia')
          let Ib = this.mqttval(item.subLoopUrl + '/Ib')
          let Ic = this.mqttval(item.subLoopUrl + '/Ic')
          let zong = Number(la) + Number(Ib) + Number(Ic);
          let v = zong / 3 / (parseFloat(JSON.parse(item.device_details)['电气']['容量']) * 1000 / 400 / Math.sqrt(3)) * 100;
          arr2.push(v.toFixed(2))
          device2.push(item.deviceName)
        })
        // current.forEach(item => {
        //   let la = this.mqttval(item.subLoopUrl + '/Ia')
        //   let Ib = this.mqttval(item.subLoopUrl + '/Ib')
        //   let Ic = this.mqttval(item.subLoopUrl + '/Ic')
        //   let zong = Number(la) + Number(Ib) + Number(Ic);
        //   let v = zong / 3 / (parseFloat(JSON.parse(item.device_details)['电气']['容量']) * 1000 / 400 / Math.sqrt(3)) * 100;
        //   arr.push(v.toFixed(2))
        //   device.push(item.deviceName)
        // })
      } else if (this.$store.getters.projectId == 19) {
        let current = this.$store.state.project.transformerList.sort((a, b) => a.deviceName.replace('变压器T', '') - b.deviceName.replace('变压器T', ''))
        console.log(current);
        current.forEach(item => {
          let val = this.mqttval(item.subLoopUrl + '/PA')
          let v = Number(val) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
          arr.push(val == '--' ? '--' : v.toFixed(2))
          let name = ""
          if (item.area_id == 75) {
            name = "1#" + item.deviceName
          } else {
            name = "2#" + item.deviceName
          }
          device.push(name)
        })
      } else {
        let current = this.$store.state.project.transformerList.sort((a, b) => a.deviceName.replace('变压器T', '') - b.deviceName.replace('变压器T', ''))
        console.log(current);
        current.forEach(item => {
          let val = this.mqttval(item.subLoopUrl + '/P')
          let v = Number(val) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
          arr.push(val == '--' ? '--' : v.toFixed(2))
          device.push(item.deviceName)
        })
      }

      return {
        values: arr,
        values2: arr2,
        device,
        device2
      }
    },
    diragmDate() {
      let colorgraphic = new echarts.graphic.LinearGradient(
          0, 1, 0, 0, [{//只要修改前四个参数就ok
            offset: 0,
            color: 'rgba(56,196,161, 0.7)'
          }, //柱图渐变色
            {
              offset: 0.55,
              color: 'rgba(56,196,161, 0.7)'
            },
            {
              offset: 1,
              color: 'rgba(246,189,22, 1)'
            }
          ]
      )
      let colorgraphic2 = new echarts.graphic.LinearGradient(
          0, 1, 0, 0, [{//只要修改前四个参数就ok
            offset: 0,
            color: 'rgba(56,196,161, 0.7)'
          }, //柱图渐变色
            {
              offset: 0.55,
              color: 'rgba(56,196,161, 0.7)'
            },
            {
              offset: 0.8,
              color: 'rgba(246,189,22, 0.7)'
            },
            {
              offset: 1,
              color: '#FD4238'
            }
          ]
      )
      let datas = this.transformerLoad.values.map(item => {
        // let datas = [110].map(item =>{
        return item = {
          value: item,
          itemStyle: {
            color: item < 80 ? 'rgba(56,196,161, 0.7)' : item >= 80 && item <= 100 ? colorgraphic : colorgraphic2
          }
        }
      })
      return {
        shadow: 'none',
        data: this.transformerLoad.device,
        max: 120,
        dataArr: datas,
        barWidth: this.transformerLoad.values.length < 5 ? 200 : null,
        labelShow: true,
        lineColor: '#F6BD16',
        label: '重载',
        label2: '过载',
        line2color: '#FD4238',
        color: ["#38C4A1"],
      }
    },
    diragmDate2() {
      return {
        shadow: 'shadow',
        data: this.temp,
        max: this.currentArr.length > 0 ? null : 100,
        dataArr: this.currentArr,
        barWidth: null,
        labelShow: false,
        lineColor: 'rgba(0,0,0,0)',
        label: '',
        label2: '',
        line2color: 'rgba(0,0,0,0)',
        color: ["#38C4A1"],
      }
    },
    chartOption() {
      let _this = this
      return {
        grid: {
          left: "0%",
          right: "3%",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        color: this.tabIdx == 2 ? this.diragmDate.color : this.diragmDate2.color,
        title: {
          text: this.menuName == '负载率' ? '%' : 'kWh',
          left: -5,// 距离左边位置
          top: 0,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ${_this.menuName == '负载率' ? '%' : 'kWh'}</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
          axisPointer: {
            type: this.tabIdx == 2 ? this.diragmDate.shadow : this.diragmDate2.shadow,
          },
        },

        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.tabIdx == 2 ? this.diragmDate.data : this.diragmDate2.data,
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            }
          },
          min: 0,
          max: this.tabIdx == 2 ? this.diragmDate.max : this.diragmDate2.max,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        series: [
          {
            data: this.tabIdx == 2 ? this.diragmDate.dataArr : this.diragmDate2.dataArr,
            type: "bar",
            barWidth: this.tabIdx == 2 ? this.diragmDate.barWidth : this.diragmDate2.barWidth,
            name: this.menuName,
            // smooth: true,
            // symbolSize:8,
            // symbol:'circle',
            // itemStyle: {
            // normal: {
            //         lineStyle: {        // 系列级个性化折线样式
            //             width: 2,
            //             type: 'solid',
            //             color: "#017fff" //折线的颜色
            //         }  ,
            //         color: 'rgba(255, 255, 255, 0)',  //拐点颜色

            //     },
            //     emphasis:{
            //         color:'#fff',
            //         borderWidth:2,
            //         borderColor:'#017fff',
            //         // shadowColor:'#00FFFF',
            //         // shadowBlur:10
            //     },
            // },
            // areaStyle: {
            //     color:{
            //     type: 'linear',
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [{
            //         offset: 0, color: 'rgba(91,153,249,0.4)' // 0% 处的颜色
            //     }, {
            //         offset: 1, color: 'rgba(91,153,249,0)' // 100% 处的颜色
            //     }],
            //     global: false // 缺省为 false
            //     }
            // },
            label: {
              show: this.tabIdx == 2 ? this.diragmDate.labelShow : this.diragmDate2.labelShow,
              position: 'top',
              // color:'red'
              fontSize: 20,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'dashed',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    // color: '#000',
                  },
                  label: {
                    show: true,
                    position: 'end'

                  }
                },
              },
              data: [
                {
                  name: 'Y 轴值为 100 的水平线',
                  yAxis: 80,
                  // 单独配置每条线的样式
                  lineStyle: {
                    color: this.tabIdx == 2 ? this.diragmDate.lineColor : this.diragmDate2.lineColor,
                  },
                  label: {
                    position: 'end',
                    formatter: this.tabIdx == 2 ? this.diragmDate.label : this.diragmDate2.label,
                    color: this.tabIdx == 2 ? this.diragmDate.lineColor : this.diragmDate2.lineColor,
                  },
                },
                {
                  name: 'Y 轴值为 100 的水平线',
                  yAxis: 100,
                  // 单独配置每条线的样式
                  label: {
                    position: 'end',
                    formatter: this.tabIdx == 2 ? this.diragmDate.label2 : this.diragmDate2.label2,
                    color: '#FD4238'
                  },
                  lineStyle: {
                    color: this.tabIdx == 2 ? this.diragmDate.line2color : this.diragmDate2.line2color,
                  }
                }
              ]
            },

          },
        ],
      };
    },
    chartOptionCH() {
      let _this = this
      return {
        grid: {
          left: "0%",
          right: "3%",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        color: this.tabIdx == 2 ? this.diragmDate.color : this.diragmDate2.color,
        title: {
          text: this.menuName == '负载率' ? '%' : 'kWh',
          left: -5,// 距离左边位置
          top: 0,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ${_this.menuName == '负载率' ? '%' : 'kWh'}</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
          axisPointer: {
            type: this.tabIdx == 2 ? this.diragmDate.shadow : this.diragmDate2.shadow,
          },
        },

        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.tabIdx == 2 ? this.transformerLoad.device2 : this.diragmDate2.data,
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            }
          },
          min: 0,
          max: this.tabIdx == 2 ? this.diragmDate.max : this.diragmDate2.max,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        series: [
          {
            barGap: this.$store.getters.projectId === 1 ? '0%' : '10%',
            data: this.tabIdx == 2 ? this.transformerLoad.values2.map(item => {
              // let datas = [110].map(item =>{
              return item = {
                value: item,
                itemStyle: {
                  color: '#5B8FF9'
                }
              }
            }) : this.diragmDate2.dataArr,
            type: "bar",
            barWidth: this.tabIdx == 2 ? this.diragmDate.barWidth : this.diragmDate2.barWidth,
            name: this.menuName,
            label: {
              show: this.tabIdx == 2 ? this.diragmDate.labelShow : this.diragmDate2.labelShow,
              position: 'top',
              // color:'red'
              fontSize: 20,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'dashed',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    // color: '#000',
                  },
                  label: {
                    show: true,
                    position: 'end'
                  }
                },
              }
            },
          },
          this.transformerLoad.values2[0] < 0 && {
            // barGap: '-100%',
            data: this.tabIdx == 2 ? this.transformerLoad.values2.map(item => {
              // let datas = [110].map(item =>{
              return item = {
                value: item,
                itemStyle: {
                  color: '#F6BD16'
                }
              }
            }) : this.diragmDate2.dataArr,
            type: "bar",
            barWidth: this.tabIdx == 2 ? this.diragmDate.barWidth : this.diragmDate2.barWidth,
            name: this.menuName,
            label: {
              show: this.tabIdx == 2 ? this.diragmDate.labelShow : this.diragmDate2.labelShow,
              position: 'top',
              // color:'red'
              fontSize: 20,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'dashed',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    // color: '#000',
                  },
                  label: {
                    show: true,
                    position: 'end'
                  }
                },
              }
            },
          },
        ],
      };
    },
  },
  mounted() {
    let _this = this
    this.tabIdx = 0
    this.getdayTimeList()
    this.getUseElectricity()
    this.timer = setInterval(() => {
      _this.getUseElectricity()
    }, 3600 * 1000)
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  watch: {
    '$store.getters.projectId'() {
      this.tabIdx = 0
      this.getUseElectricity()
    }
  },
  methods: {
    tabMenu(idx) {
      this.tabIdx = idx
      if (idx == 0) {
        this.menuName = '用电量'
      } else if (idx == 1) {
        this.menuName = '发电量'
      } else {
        this.menuName = '负载率'
      }
      this.tabDate(0)
    },
    getMqttVal(f) {
      return (k, m) => {
        if (k) {
          let mqttVal = f(k);
          if (m) {
            mqttVal *= m;
          }
          mqttVal = Number(mqttVal).toFixed(2);
          if (typeof mqttVal === "object") {
            return mqttVal;
          }
          return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
        } else {
          return "--";
        }
      };
    },
    tabDate(idx) {
      this.isFull = false
      this.dateIdx = idx
      if (idx == 0) {
        this.temp = this.hoursTimeList
      } else if (idx == 1) {
        this.temp = this.dayTimeList
      } else if (idx == 2) {
        this.temp = this.monTimeList
      }
      this.$nextTick(() => {
        this.isFull = true
      })

      if (this.tabIdx == 0) {
        this.currentArr = this.useList[idx]
      } else if (this.tabIdx == 1) {
        this.currentArr = this.generList[idx]
      } else {

        // this.currentArr = this.workloadList[idx]
      }

    },
    async getUseElectricity() {
      this.useList = [[], [], []]
      this.generList = [[], [], []]
      this.workloadList = [[], [], []]
      let _this = this
      let date = dayStart(new Date()).split('T')[0]
      let projectId = this.$store.getters.projectId

      let data = {
        date,
        projectId,
        range: 'hour',
        reportType: 'use'
      }
      let data2 = {
        date,
        projectId,
        range: 'day',
        reportType: 'use'
      }
      let data3 = {
        date,
        projectId,
        range: 'month',
        reportType: 'use'
      }
      let data4 = {
        date,
        projectId,
        range: 'hour',
        reportType: 'generate'
      }
      let data5 = {
        date,
        projectId,
        range: 'day',
        reportType: 'generate'
      }
      let data6 = {
        date,
        projectId,
        range: 'month',
        reportType: 'generate'
      }
      let data7 = {
        date,
        projectId,
        range: 'hour',
        reportType: 'workload'
      }
      let data8 = {
        date,
        projectId,
        range: 'day',
        reportType: 'workload'
      }
      let data9 = {
        date,
        projectId,
        range: 'month',
        reportType: 'workload'
      }

      try {
        let res = await Promise.all([
          getOverviewReport(data),
          getOverviewReport(data2),
          getOverviewReport(data3),
        ])

        let res1 = await Promise.all([
          getOverviewReport(data4),
          getOverviewReport(data5),
          getOverviewReport(data6),
        ])

        let res2 = await Promise.all([
          getOverviewReport(data7),
          getOverviewReport(data8),
          getOverviewReport(data9),
        ])
        // console.log(res);
        // return
        res.forEach((item, index) => {
          // _this.useList[index] = Object.values(item.data.data)
          if (item.data.data.length > 0) {
            let arr = []
            item.data.data.forEach((itme1, idx1) => {
              arr[idx1] = itme1.value
            })
            _this.useList[index] = arr
          } else {
            _this.useList[index] = item.data.data
          }
        })
        // console.log(res1);
        res1.forEach((item, index) => {
          // console.log(item.data.data[index]);
          if (item.data.data.length > 0) {
            let arr = []
            item.data.data.forEach((itme1, idx1) => {
              arr[idx1] = itme1.value
            })
            _this.generList[index] = arr
            // console.log(arr);
            // console.log(Object.values(item.data.data));
          } else {
            _this.generList[index] = item.data.data
          }

        })
        // console.log(res2);
        res2.forEach((item, index) => {
          if (item.data.data.length > 0) {
            let arr = []
            item.data.data.forEach((itme1, idx1) => {
              // console.log(itme1);
              arr[idx1] = (itme1.value / 1000).toFixed(2)
            })
            _this.workloadList[index] = arr
          } else {
            _this.workloadList[index] = item.data.data
          }

        })

        this.tabMenu(this.tabIdx)
      } catch (err) {
        console.log(err);
      }
    },
    getdayTimeList() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = new Date(year, month, 0)
      for (let i = 0; i < day.getDate(); i++) {
        this.dayTimeList[i] = (i + 1) + '日'
      }

      for (let i = 1; i <= 12; i++) {
        this.monTimeList.push(i + "月");
      }

      for (let i = 0; i < 25; i++) {
        this.hoursTimeList.push(i + '点')
      }
      this.temp = this.hoursTimeList
    }
  }
};
</script>
<style lang="less" scoped>
.diagram {
  .tag {
    span {
      display: inline-block;
      font-size: 16rem;
      font-weight: bold;
      border-top: 2px solid #ffffff;
      margin: 0 20rem;
      line-height: 50rem;
      cursor: pointer;
    }

    .active {
      border-top: 2px solid #0d94ff;
      color: #0d94ff;

    }
  }

  .cont {
    // justify-content: space-between;
    padding: 0 20px;

    .left {
      .w(963);
      .h(250);
      position: relative;

      .nothing {
        position: absolute;
        top: 2vh;
        left: 0%;
        right: 0%;
        margin: auto;
        width: 16vw;
        height: 18vh;
        background: url('../../../assets/img/not_found_data.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .full {
      width: 100%;
    }

    .right {
      margin-right: 22rem;

      span {
        display: block;
        width: 142rem;
        height: 56rem;
        line-height: 56rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4rem;
        font-size: 16px;
        font-weight: bold;
        margin: 16rem 0;
        cursor: pointer;
      }

      .active {
        background: rgba(14, 156, 255, 0.12);
        color: #0d94ff;
      }
    }

    .hd {
      display: none;
    }
  }
}
</style>